<div class="notification-failed">
<div class="event-item">
    <!-- <span class="notification-activity dismiss" (click)="dismiss()">Dismiss</span> -->
    <div class="header-notification">
      <h3>Saving Annotations</h3> <strong>FAILED</strong>
    </div>
    <p>The annotation you tried to set could not be saved.</p>
    <p>Click <span (click)="refreshPage()" class="action-link">here</span> to refresh the application.</p>
</div>
</div>